import {Component, Input, OnInit} from '@angular/core';
import {Router, ActivatedRoute, Params} from "@angular/router";
import {Location} from '@angular/common';

//import { UsuarioService } from '../usuario/usuario.service';
import {Usuario} from '../usuario/usuario';
import {AcessoService} from "./acesso.service";

@Component({
    selector: 'app-acesso',
    templateUrl: './acesso.component.html',
    styleUrls: ['./acesso.component.css'],
    providers: [AcessoService]

})
export class AcessoComponent implements OnInit {

    email: string;
    senha: string;
    acesso: string;
    usuario: Usuario;

    onSubmit() {

        //this.usuario.id = 0;
        //this.usuario.nome = null;
        //this.usuario.email = this.email;
        //this.usuario.telefone = null;
        //this.usuario.profissao = null;
        //this.usuario.senha = this.senha;
        let self = this;

        this.AcessoService.login(this.usuario).then(function (retorno) {
			self.AcessoService.setUsuario(retorno);
            self.router.navigateByUrl('eventos');
        });
    }

    constructor(private AcessoService: AcessoService,
                private router: Router,
                private route: ActivatedRoute,
                private location: Location) {
        this.usuario = new Usuario;
    }

    ngOnInit() {
        this.email = "";
        this.senha = "";
    }

}



// WEBPACK FOOTER //
// ./src/app/acesso/acesso.component.ts